<details class="disclosure" [open]="open()">
  <summary class="disclosure-summary">{{ summary() }}</summary>
  <div class="disclosure-body">
    <ng-content />
  </div>
</details>
